import { Box, Typography, useTheme } from '@mui/material';

const HourRuler = ({ hourWidth = 56 }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: 'flex', height: 28, flexShrink: 0 }}>
      {Array.from({ length: 24 }, (_, i) => (
        <Box
          key={i}
          sx={{
            width: hourWidth,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.dark',
            borderRight: `1px solid ${theme.palette.divider}`,
          }}
        >
          <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.6rem', fontFamily: 'monospace' }}>
            {String(i).padStart(2, '0')}:00
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default HourRuler;
